import { hDeepCopy } from "@/utils/helpers";
import ShPopConfirm from "@/components/Helpers/ShPopConfirm";
import IvrSingleMessageItem from "../../../Common/IvrSingleMessageItem";

// @vue/component
export default {
  name: "IvrBasicMessagesMainConfig",

  components: {
    ShPopConfirm,
    IvrSingleMessageItem
  },

  props: {
    projectUuid: {
      type: String,
      default: null
    },
    config: {
      type: Object,
      default: () => ({})
    },
    pollyConfigDictionary: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      editableConfig: {}
    };
  },

  created() {
    this.editableConfig = hDeepCopy(this.config);
  },
  computed: {
    activePollyVoiceForUser() {
      return this.pollyConfigDictionary["voice"].filter(v => {
        return v.show_user || v.value_number === this.config.voice_mode;
      });
    }
  },
  methods: {
    async submitChanges() {
      const params = {
        project: this.projectUuid,
        delay_between_voice: this.editableConfig.delay_between_voice,
        voice_mode: this.editableConfig.voice_mode,
        voice_speed: this.editableConfig.voice_speed,
        first_lang: this.editableConfig.first_lang,
        second_lang: this.editableConfig.second_lang,
        ask_en_voice: this.editableConfig.ask_en_voice ? "true" : "false"
      };

      await this.$store.dispatch("client/project/ivrBasicMessages/updateIvrMessages", params);
      await this.$store.dispatch("client/project/ivrBasicMessages/getDetails", this.projectUuid);

      if (
        this.editableConfig.voice_mode !== this.config.voice_mode ||
        this.editableConfig.voice_speed !== this.config.voice_speed
      ) {
        this.$nextTick(() => {
          this.$EventBus.$emit("IvrBasicMessagesMainConfig/OPEN_REGENERATE_IVR_MESSAGES_FORM");
        });
      }
    },
    openRegenarteIvrMessagesForm() {
      this.$EventBus.$emit("IvrBasicMessagesMainConfig/OPEN_REGENERATE_IVR_MESSAGES_FORM");
    }
  }
};
